import { asyncToGenerator as _asyncToGenerator } from './_virtual/_rollupPluginBabelHelpers.js';
import _regeneratorRuntime from 'regenerator-runtime';

var PAGE_DATA_FILE_NAME = 'page-data.json'; // TODO: for better performance we can check
// and see if matchedRoute component have getInitialProps or not
// if the page dose not have a getInitalProps, then page-data.json is empty

/**
 * reads data from pathname/page-data.json file using (fetch method) and then return it
 * @param routes
 * @param pathname
 */

function loadStaticProps(_x) {
  return _loadStaticProps.apply(this, arguments);
}

function _loadStaticProps() {
  _loadStaticProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pathname) {
    var PAGE_DATA_FILE_PATH;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // in ssg mode there is always a file called page-data.json next to the
            // page path that we have in our app this page-data.json file includes inital data that we need
            // to inject to our components before we render the component
            // if pathname equals "/" we are going to fetch data for https://page-data.json path
            // which is WRONG so we fallback to empty string for index page /page-data.json
            PAGE_DATA_FILE_PATH = (pathname === '/' ? '' : pathname) + "/" + PAGE_DATA_FILE_NAME;
            return _context.abrupt("return", fetch(PAGE_DATA_FILE_PATH).then(function (res) {
              return res.json();
            }).then(function (res) {
              return {
                data: res
              };
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadStaticProps.apply(this, arguments);
}

export { loadStaticProps };
//# sourceMappingURL=loadStaticProps.esm.js.map
